import React from 'react';

import { ListItem, Text } from '@change/ds-core-ui';
import {
	ChatBubbleIcon,
	DecisionMakerIcon,
	MediaIcon,
	PetitionIcon,
	SignaturesIcon,
	VictoryIcon,
} from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { useLearnHowSection } from './hooks/useLearnHowSection';

export const LearnHowSection: React.FC = () => {
	const {
		data: { coreArticles },
		actions: { trackArticleClick },
	} = useLearnHowSection();

	// These icons will map to the order of the articles
	const coreArticleIcons = [PetitionIcon, SignaturesIcon, ChatBubbleIcon, MediaIcon, DecisionMakerIcon, VictoryIcon];

	if (coreArticles.length === 0) {
		return null;
	}

	return (
		<div className="space-y-4">
			<Text className="block" size="small" variant="heading" fontWeight="light">
				<Translate value="corgi.petition_guides_article.page_body.sidebar.learn_how_section.title" />:
			</Text>

			<div>
				{coreArticles.map((article) => {
					const IconComponent = coreArticleIcons[coreArticles.indexOf(article)] ?? PetitionIcon;

					return (
						<ListItem
							as="a"
							href={`/petition-guides/${encodeURIComponent(article.slug)}?source_location=${article.slug}-article`}
							key={article.slug}
							data-qa={`${article.slug}-sidebar-link`}
							className="px-0 py-2 no-underline"
							label={
								<Text size="x-small" variant="heading">
									{article.headingShort}
								</Text>
							}
							leadingSlot={
								<div className="flex items-center justify-center rounded-md p-2">
									<IconComponent />
								</div>
							}
							forceInteractive
							onClick={trackArticleClick}
						/>
					);
				})}
			</div>
		</div>
	);
};
